import React, { useState, useEffect } from "react";
import { EditView } from "../components/EditView";
import { SearchPanel } from "../components/SearchPanel";
import { AddView } from "../components/AddView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import useToggleScroll from "../components/useToggleScroll";

export function Bars() {
  const [bars, setBars] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [addView, setAddView] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);

  useToggleScroll([addView]);

  const handleRowClick = (key) => {
    setSelectedRow(selectedRow === key ? null : key);
  };

  function handleClick() {
    setAddView(!addView);
  }
  function handleChange(e) {
    if (e.target.name === "showDeletedArticles") {
      setShowDeleted(e.target.checked);
    }
  }

  const fetchData = () => {
    setSelectedRow(null);
    setLoading(true);

    let command = "Select";
    if (showDeleted) {
      command = "Select-Deleted";
    }

    fetch(`https://inventy.redata.se/inventdb/api_bars.php?Command=${command}`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setBars(data);
        } else {
          console.error("Fetched data is not an array:", data);
          setBars([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setBars([]); // Set products to an empty array on error
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [showDeleted]); // Dependencies array

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <SearchPanel setSearch={setSearch} />
        <div className="SearchPanel">
          {localStorage.getItem("Admin") == 1 && (
            <button className="hoverButton" onClick={handleClick}>
              Lägg till bar
            </button>
          )}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "1vh",
          margin: "1vh",
        }}
      >
        <div>
          <label htmlFor="showDeletedArticles">Visa raderade artiklar </label>
          <input
            type="checkbox"
            id="showDeletedArticles"
            name="showDeletedArticles"
            value="1"
            checked={showDeleted}
            onChange={handleChange}
          />
        </div>
      </div>
      {addView && (
        <AddView setAddView={setAddView} refresh={fetchData} type="Bar" />
      )}
      <table
        style={{
          width: "50%",
          textAlign: "left",
          marginTop: "4vh",
        }}
      >
        <tbody>
          {bars.map((bar) => {
            if (
              search === "" ||
              bar.name.toLowerCase().includes(search.toLowerCase())
            ) {
              if (
                selectedRow === bar.ID &&
                localStorage.getItem("Admin") == 1
              ) {
                return (
                  <EditView
                    object={bar}
                    id={bar.ID}
                    refresh={fetchData}
                    type="Bar"
                    key={bar.ID}
                  />
                );
              } else {
                return (
                  <tr
                    className={`hoverButton ${bar.deleted == 1 ? "deletedRow" : ""}`}
                    onClick={() => handleRowClick(bar.ID)}
                    key={bar.ID}
                  >
                    <td>
                      <h3 style={{ padding: "1vh" }}>
                        {bar.deleted == 1 && <FontAwesomeIcon icon={faTrash} />}
                        {" " + bar.name}
                      </h3>
                    </td>
                  </tr>
                );
              }
            }
          })}
        </tbody>
      </table>
    </div>
  );
}
